module.exports = __webpack_public_path__ + "static/media/multiplayer.6f817a1b.svg";